"use strict";

/**
* Реквизит типа «Выбор из справочника» и «Множественный выбор».
* 
* @class WebAccess.components.wrappers.form.requisites.CheckBox
* @extends WebAccess.components.wrappers.form.requisites.BaseRequisite
* @property {string} name Имя реквизита
* @param {string} requisiteName Имя реквизита
* @param {obbject} data Данные для инициализации реквизита
* @since 5.0.0.7100
*/
(function (global) {

  /**
* @inner
* @since 5.2.0.2014
*/

  var CheckBox = global.WA.CMP.wrappers.form.requisites.BaseRequisite.extend({
    className: "CheckBox",

    /**
    * Получить контролы реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.CheckBox#_bindEvents
    * @private
    * @return {array} список jquery объектов
    * @since 5.0.0.7100
    */
    _getControls: function () {
      var me = this;
      var res = [];

      if (me.controlsIds.length == 0 || me.controlsIds[0] == "") return [];

      for (var i = 0; i < me.controlsIds.length; i++) {
        var id = me.controlsIds[i];        
        var selector = '[id="' + id + '"]';
        var jControl = $(selector);
        res.push(jControl);
      }
      return res;
    },
    //---------------------------------------------------------------------//


    /**
    * Отобразить спиннер внутри контрола реквизита
    * @method WebAccess.components.wrappers.form.requisites.CheckBox#_showSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.CheckBox
    */
    _showSpinner: function () {
      var me = this;      
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Скрыть спиннер
    * @method WebAccess.components.wrappers.form.requisites.CheckBox#_hideSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.CheckBox
    */
    _hideSpinner: function () {
      var me = this;
      return me;
    },
    //---------------------------------------------------------------------//

    /**   
    * Получить значение реквизита.
    * 
    * @ignore
    * @method WebAccess.components.wrappers.form.requisites.CheckBox#getDisplayValue
    * @return {string} Строка, содержащая отображаемое значение реквизита.
    */
    getDisplayValue: function (opt_jControl) {            
      return '';
    },
    //---------------------------------------------------------------------//    

    /**   
    * Установить значение отображаемых и неотображаемых реквизитов.
    *
    * @method WebAccess.components.wrappers.form.requisites.CheckBox#setValue
    * @param value {string} Устанавливаемое значение
    * @param [opt_displayValue] {string} Отображаемое значение
    * @param [opt_needTriggerResult] {string} Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites.CheckBox} Текущий объект реквизита – Reference.
    * @since 5.0.0.7100
    */
    setValue: function (value, opt_displayValue, opt_needTriggerResult) {
      var me = this;
      opt_needTriggerResult = (opt_needTriggerResult !== false);

      if (this.controls.length === 0) return this._setInvisibleValues(value, opt_displayValue, opt_needTriggerResult);

      $.each(me.controls, function () {
        $(this).prop('checked', value);
      });

      this.touch();
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * @ignore
    * @method WebAccess.components.wrappers.form.requisites.CheckBox#setDisplayValue
    */
    setDisplayValue: function (displayValue, opt_needTriggerResult) {
      var me = this;    
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Получить значение в поле по его имени.
    *
    * @private
    * @function WebAccess.components.wrappers.form.requisites.CheckBox#_getControlValue
    * @since 5.0.0.7100
    */
    _getControlValue: function (controlName) {
      if (this.controls.length === 0) return;
      return $(this.controls[0]).is(':checked');      
    },
    //---------------------------------------------------------------------//  

    /**
   * Установить подпись для реквизита.
   *
   * @function  WebAccess.components.wrappers.form.requisites.BaseRequisite#setLabel
   * @ignore
   * @return {WebAccess.components.wrappers.BaseRequisite} Текущий объект реквизита.
   */
    setLabel: function (text) {
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Получить контрол подписи.
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_getLabelForControl
    * @private
    * @since 5.0.0.7100
    * @return {object}
    */
    _getLabelForControl: function (jControl) {
      var jC = jControl.parents('.Card_Element:first').prev('.CardForm_Label');
      if (jC.length) return jC;
      jC = jControl.parents('label');
      return jC;
    },
    //---------------------------------------------------------------------//
          
    /**
    * @method WebAccess.components.wrappers.form.requisites.CheckBox#setCustomAction
    * @ignore 
    */
    setCustomAction: function() {
      return this;
    }
    //---------------------------------------------------------------------//

  });

  global.WA.CMP.wrappers.form.requisites.CheckBox = CheckBox;
})(window);